import { render, staticRenderFns } from "./textEditor.vue?vue&type=template&id=dfed83ec&scoped=true&"
import script from "./textEditor.vue?vue&type=script&lang=js&"
export * from "./textEditor.vue?vue&type=script&lang=js&"
import style0 from "./textEditor.vue?vue&type=style&index=0&id=dfed83ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfed83ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\www\\ssz_gold_backend\\multi_merchant_web\\gold_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dfed83ec')) {
      api.createRecord('dfed83ec', component.options)
    } else {
      api.reload('dfed83ec', component.options)
    }
    module.hot.accept("./textEditor.vue?vue&type=template&id=dfed83ec&scoped=true&", function () {
      api.rerender('dfed83ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/textEditor.vue"
export default component.exports